<template>
  <div>
    <div style="margin: 20px">لطفا یکی از دوره های زیر را انتخاب نمایید:</div>
    <div v-if="isMobile">
      <v-card v-for="item in items" :key="item.FSerial">
        <v-card-title class="info-detail">
          <v-radio-group v-model="selectedDoreh">
            <v-radio label="" :value="item"></v-radio>
          </v-radio-group>
          <div class="text-center">
            {{ item.FName }}
          </div>
        </v-card-title>
        <div
          class="contain"
          :style="[
            selectedDoreh != null && item.FSerial == selectedDoreh.FSerial
              ? { 'background-color': '#00d10040' }
              : '',
          ]"
        >
          <app-row icon="hashtag" title="کد : " :value="item.FCode" />

          <app-row icon="users" title="جنسیت: " :value="item.Jensiat" />
        </div>
      </v-card>
    </div>
    <div v-else>
      <v-data-table
        :headers="headers"
        :items="items"
        item-key="FSerial"
        show-select
        single-select
        class="elevation-1 rounded2"
        :no-data-text="tableText"
        :disable-pagination="true"
        :hide-default-footer="true"
      >
        <template v-slot:[`item.data-table-select`]="{ item }">
          <v-radio-group v-model="selectedDoreh">
            <v-radio label="" :value="item"></v-radio>
          </v-radio-group>
        </template>
      </v-data-table>
    </div>
    <app-actions
      @nextStep="nextStep"
      :showCancel="true"
      @prevStep="prevStep"
    ></app-actions>
  </div>
</template>

<script>
import Actions from "./Actions";
import DetailRow from "@/components/DetailRow";
export default {
  components: {
    appActions: Actions,
    appRow: DetailRow,
  },
  data() {
    return {
      selectedDoreh: null,
      headers: [
        {
          text: "",
          value: "FSerial",
          width: "0px",
          sortable: false,
        },
        {
          text: "کد",
          value: "FCode",
          width: "10%",
        },
        {
          text: "نام دوره",
          value: "FName",
          width: "80%",
        },
        {
          text: "جنسیت",
          value: "Jensiat",
          width: "10%",
        },
      ],
    };
  },
  props: ["items"],
  methods: {
    nextStep() {
      if (this.selectedDoreh == null) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "دوره ای برای تدریس انتخاب نشده است."
        );

        return;
      } else {
        this.$emit("nextStep", this.selectedDoreh);
      }
    },
    prevStep() {
      this.$emit("prevStep");
    },
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
};
</script>
<style>


.rounded2 thead th:nth-child(2) {
  display: none;
}

.rounded2 tbody tr td:nth-child(2) {
  display: none;
}
</style>
